import { Block } from 'webiq.boilerplate'
import intlTelInput from 'intl-tel-input/build/js/intlTelInputWithUtils'
import { checkVAT, countries } from 'jsvat'
import { postcodeValidator, postcodeValidatorExistsForCountry } from 'postcode-validator';

const filteredCountries = countries.filter(item => item.name)

// const NETHERLANDS_COUNTRY_ID = '150'
// const GERMANY_COUNTRY_ID = '80'
// const BELGIUM_COUNTRY_ID = '26'
const AUSTRALIA_COUNTRY_ID = '13'
const CANADA_COUNTRY_ID = '38'
const USA_COUNTRY_ID = '226'
const BRAZIL_COUNTRY_ID = '30'
const CHILE_COUNTRY_ID = '43'
const ARGENTINA_COUNTRY_ID = '10'
const CHINA_COUNTRY_ID = '44'
const INDA_COUNTRY_ID = '99'
const INDONESIA_COUNTRY_ID = '100'
const ITALY_COUNTRY_ID = '105'
const JAPAN_COUNTRY_ID = '107'
const MEXICO_COUNTRY_ID = '138'
const THAILAND_COUNTRY_ID = '211'
const STATE_COUNTRIES = [
	AUSTRALIA_COUNTRY_ID,
	CANADA_COUNTRY_ID,
	USA_COUNTRY_ID,
	BRAZIL_COUNTRY_ID,
	CHILE_COUNTRY_ID,
	ARGENTINA_COUNTRY_ID,
	CHINA_COUNTRY_ID,
	INDA_COUNTRY_ID,
	INDONESIA_COUNTRY_ID,
	ITALY_COUNTRY_ID,
	JAPAN_COUNTRY_ID,
	MEXICO_COUNTRY_ID,
	THAILAND_COUNTRY_ID
]

export default class CheckoutAddress extends Block {
	static title = 'checkout-address'

	init() {
		this.phoneField = this.element.querySelector('input#phone')
		this.radioGroup = this.getElement('radiogroup')
		this.b2bContainer = this.getElement('b2b')
		this.vatCountry = this.element.querySelector('.checkout-address__country:not(.checkout-address__invoice-field)')
		this.countrySelect = this.getElements('country')
		this.stateFields = this.element.querySelectorAll('.checkout-address__state', '.checkout-address__invoice-state')
		
		this.invoiceCheckbox = this.getElement('invoice-checkbox')
		this.invoiceContainer = this.getElement('invoice-container')
		this.invoiceFields = this.getElements('invoice-field')

		this.form = this.getElement('form')

		if (this.radioGroup) {
			this.radioGroup.addEventListener('sl-change', (e) => {
				if (e.currentTarget.value == "business") {
					this.b2bContainer.classList.remove('tw-hidden')
				} else {
					this.b2bContainer.classList.add('tw-hidden')
				}
			})
		}

		if (this.phoneField) {
			this.input = intlTelInput(this.phoneField, {
				nationalMode: false,
				separateDialCode: true,
				initialCountry: "auto",
				autoInsertDialCode: true,
				useFullscreenPopup: false,
				formatOnDisplay: false,
				showFlags: true,
				hiddenInput: () => ({
					phone: 'phone',
					country: 'country_code',
				}),
				geoIpLookup: callback => {
					fetch("https://ipapi.co/json")
					.then(res => res.json())
					.then(data => callback(data.country_code))
					.catch(() => callback("nl"));
				},
			});
	
			if (this.element.hasAttribute('data-phone')) {
				this.input.setNumber(this.element.getAttribute('data-phone'))
			}
	
			const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
	
			this.phoneField.addEventListener('blur', () => {
				window.eventEmitter.emit('message:close')
				if (this.phoneField.value.trim()) {
					if (!this.input.isValidNumber()) {
						const errorCode = this.input.getValidationError();
						window.eventEmitter.emit('product:add-fail', {error: errorMap[errorCode]})
						this.element.querySelector('button[type="submit"]').disabled = true
					} else {
						this.element.querySelector('button[type="submit"]').disabled = false
					}
				}
			})
		}

		if (this.invoiceCheckbox && this.invoiceContainer) {
			this.invoiceCheckbox.addEventListener('change', (e) => {
				if (!e.currentTarget.checked) {
					this.invoiceContainer.classList.remove('tw-hidden')
					this.invoiceFields.forEach(element => {
						element.disabled = false
					})
				} else {
					this.invoiceContainer.classList.add('tw-hidden')
					this.invoiceFields.forEach(element => {
						element.disabled = true
					})
				}
			})
		}

		// address validation copied from original dir, but changed to fit new checkout structure

		this.autoCompleteFields = this.element.querySelectorAll(
			'[name="zipcode"], [name="number"], [name="invoice_address[zipcode]"], [name="invoice_address[number]"]',
		)
		this.zipcodeInput = this.element.querySelector('[name="zipcode"]')
		this.houseNumberInput = this.element.querySelector('[name="number"]')
		this.streetInput = this.element.querySelector('[name="street"]')
		this.cityInput = this.element.querySelector('[name="city"]')

		this.vatInput = this.element.querySelector('[name="properties[3]"]')
		this.countryListed = false

		this.messageBlock = this.element.querySelector('.message--address')

		this.checkState = this.form.dataset.checkState
		if (this.checkState) {
			this.requireStateId()
		}

		if (this.form.dataset.autocomplete) {
			this.autocompleteAddress(this.form.getAttribute('data-autocomplete'))
		}

		this.closeButton = this.getElement('close')
		if (this.closeButton) {
			this.closeButton.addEventListener('click', () => this.toggle())
		}

		this.form.addEventListener('submit', (e) => this.checkSubmit(e))
		
		this.vatCountry.addEventListener('sl-change', () => {
			this.countryChange()
		})

		this.vatMessage = document.querySelector('.message--vat')
		this.vatCountryMessage = document.querySelector('.message--vat_country');

		try {
			this.rawData = document.getElementById('register-countries')
			this.data = JSON.parse(this.rawData.textContent)
		} catch(e) {
			//
		}

		this.vatInput?.addEventListener('sl-change', () => this.checkVatNumber())
	}

	requireStateId() {
		this.countrySelect.forEach((countrySelect) => {
			countrySelect.addEventListener('sl-change', (e) => {
				const selectedCountryId = e.currentTarget.value

				const stateFields = this.element.querySelectorAll('.checkout-address__state, .checkout-address__invoice-state')
	
				stateFields.forEach((stateSelect) => {
					const selectElement = stateSelect.querySelector('sl-select')
	
					if (
						stateSelect.dataset.countryId == selectedCountryId &&
						STATE_COUNTRIES.includes(selectedCountryId) &&
						e.currentTarget.dataset.type == stateSelect.dataset.type
					) {
						stateSelect.classList.remove('tw-hidden')
						selectElement.required = true
						selectElement.disabled = false
						return
					}
	
					stateSelect.classList.add('tw-hidden')
					selectElement.required = false
					selectElement.disabled = true
				})
			})
		})
	}

	autocompleteAddress(countryId) {
		if (!this.countrySelect && !this.form.dataset.noCountrySelect) {
			return
		}

		this.autoCompleteFields.forEach((field) => {
			field.addEventListener('sl-change', (e) => {
				const countrySelect = this.element.querySelector('[data-type="'+ field.dataset.type + '"]')
				if (
					(field.name == 'zipcode' || field.name == 'invoice_address[zipcode]') &&
					this.form.dataset.checkZipcode &&
					field.value != ''
				) {
					if (!this.checkZipcode(field)) {
						this.showErrorMessage('Invalid zip')
						return
					}

					this.toggleMessageBlock(false)
				}

				let houseNumberInput
				let zipcodeInput
				if (field.dataset.type == 'country') {
					houseNumberInput = this.element.querySelector('[name="number"][data-type="country"]')
					zipcodeInput = this.element.querySelector('[name="zipcode"][data-type="country"]')
				}
				if (field.dataset.type == 'invoice') {
					houseNumberInput = this.element.querySelector('[name="invoice_address[number]"][data-type="invoice"]')
					zipcodeInput = this.element.querySelector('[name="invoice_address[zipcode]"][data-type="invoice"]')
				}

				if (countrySelect && countrySelect.value !== countryId) {
					return
				}

				if (!zipcodeInput.value || !houseNumberInput.value) {
					return
				}

				this.getAutocompletedAddress(
					zipcodeInput.value,
					houseNumberInput.value,
					field.dataset.type
				)
			})
		})
	}

	checkZipcode(field) {
		const zipcode = field.value

		const countrySelect = this.element.querySelector('[data-type="'+ field.dataset.type + '"]')
		const alpha2 = countrySelect.getAttribute('data-alpha2')
		const canValidate = postcodeValidatorExistsForCountry(alpha2)

		if (alpha2 == "NL") {
			zipcode = zipcode.toUpperCase()
		}

		if (canValidate) {
			const isValidZipcode = postcodeValidator(zipcode, alpha2)
			if (isValidZipcode) {
				return true
			} else {
				this.showErrorMessage()
			}
		} else {
			return true
		}
	}

	getAutocompletedAddress(zipcode, houseNumber, type) {
		const payload = new FormData()
		payload.append('zipcode', zipcode)
		payload.append('number', houseNumber)
		payload.append('validate', '1')

		fetch('/zipcode', {
			method: 'POST',
			body: payload,
			credentials: 'same-origin',
		})
			.then((response) => response.json())
			.then((json) => {
				this.fillAutocompleteFields(json, type)
			})
			.catch((error) => this.showErrorMessage(error))
	}

	fillAutocompleteFields(obj, type) {
		if (obj.error) {
			this.showErrorMessage(obj.error)
		}

		let streetInput
		let cityInput
		if (
			type == "country") {
			streetInput = this.element.querySelector('[name="street"][data-type="country"]')
			cityInput = this.element.querySelector('[name="city"][data-type="country"]')
		}
		if (type == "invoice") {
			streetInput = this.element.querySelector('[name="invoice_address[street]"][data-type="invoice"]')
			cityInput = this.element.querySelector('[name="invoice_address[city]"][data-type="invoice"]')
		}

		if (!streetInput || !cityInput || !obj.result) {
			return
		}

		this.toggleMessageBlock(false)

		streetInput.value = obj.result.street
		cityInput.value = obj.result.city
	}

	countryChange() {
		// CoC number is required for Brazilian consumers
		const countryId =
			this.vatCountry.value

		if (
			[BRAZIL_COUNTRY_ID, CHILE_COUNTRY_ID].includes(countryId) &&
			this.vatInput
		) {
			this.vatInput.required = true
			this.vatInput.label = this.vatInput.dataset.requiredText
			this.radioGroup.value = "business"
			this.radioGroup.classList.add("tw-pointer-events-none")
			this.radioGroup.classList.add("tw-opacity-50")
			this.b2bContainer.classList.remove('tw-hidden')
			return
		} else {
			this.radioGroup.classList.remove("tw-pointer-events-none")
			this.radioGroup.classList.remove("tw-opacity-50")
		}

		this.vatInput.label = this.vatInput.dataset.notRequiredText
		this.vatInput.required = false

		this.zipcodeInput.value = null
		this.checkVatNumber()
	}
	
	checkVatNumber() {
		this.countryListed = false

		this.data.forEach((el) => {
			if (this.vatCountry.value === el.id) {
				this.selectedCountry = el.alpha2
			}
		})

		this.check = checkVAT(this.vatInput.value, filteredCountries)
		
		if(!this.check.value) {
			this.removeErrors()
			return null
		}

		countries.forEach(country => {
			if(country.codes['0'] === this.selectedCountry) {
				this.countryListed = true
				this.vatMessage.classList.remove('message--active')
				this.vatCountryMessage.classList.add('message--active')
				return null
			}
		})

		if(this.countryListed === false) {
			this.removeErrors()
			return null
		}

		if(this.check.isSupportedCountry && this.check.country.isoCode.short !== this.selectedCountry) {
			this.vatMessage.classList.remove('message--active')
			this.vatCountryMessage.classList.add('message--active')
			return null
		}

		if(!this.check.country) {
			this.vatCountryMessage.classList.remove('message--active')
			this.vatMessage.classList.add('message--active')
			return null
		}

		if(!this.check.isValidFormat) {
			// this.field.classList.add('mdc-text-field--validation-error')
			this.vatCountryMessage.classList.remove('message--active')
			this.vatMessage.classList.add('message--active')
		} else {
			this.removeErrors()
		}
	}

	removeErrors() {
		// this.field.classList.remove('mdc-text-field--validation-error')
		this.vatMessage.classList.remove('message--active')
		this.vatCountryMessage.classList.remove('message--active')
	}

	checkSubmit(e) {
		if (!this.checkZipcode(this.zipcodeInput)) {
			e.preventDefault()
		}
	}

	toggle() {
		this.toggleModifier('hidden')
	}

	showErrorMessage(error) {
		if (!this.messageBlock || !error) {
			return
		}

		this.messageBlock.textContent = error
		this.toggleMessageBlock(true)
	}

	toggleMessageBlock(state = null) {
		if (!this.messageBlock) {
			return
		}

		if (state === null) {
			this.messageBlock.classList.toggle('message--active')
			this.messageBlock.classList.toggle('message--hidden')
			return
		}

		if (state === true) {
			this.messageBlock.classList.add('message--active')
			this.messageBlock.classList.remove('message--hidden')
			return
		}

		this.messageBlock.classList.remove('message--active')
		this.messageBlock.classList.add('message--hidden')
	}
}
